import React, { useEffect, useState } from "react";
import client, { formatApiError } from "@/lib/api";
import AdminPageHeader from "@/components/admin/AdminPageHeader";
import SchoolAnalyticsView from "@/components/SchoolAnalyticsView";
import { TrendingUp } from "lucide-react";

/**
 * Admin's "School Progress" — a school picker in front of the shared
 * SchoolAnalyticsView. See that component's own comment for what this
 * feature covers and how it's adapted from the sibling Little Verses app.
 */
export default function AdminSchoolAnalytics() {
  const [schools, setSchools] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    client.get("/admin/school-analytics/schools")
      .then(({ data }) => {
        setSchools(data.schools);
        if (data.schools.length) setSchoolId(data.schools[0].id);
      })
      .catch((ex) => setErr(formatApiError(ex.response?.data?.detail) || ex.message));
  }, []);

  return (
    <div data-testid="admin-school-analytics">
      <AdminPageHeader
        icon={TrendingUp}
        title="School Progress"
        subtitle="How each school's students are doing — right now, and over any period you choose."
        actions={
          schools && schools.length > 0 && (
            <select
              value={schoolId || ""}
              onChange={(e) => setSchoolId(e.target.value)}
              data-testid="school-picker"
              className="rounded-full border-2 border-[#E5DFC8] bg-white px-4 py-2 min-h-[44px] text-sm font-bold text-hv-navy focus:outline-none focus:border-hv-teal"
            >
              {schools.map((s) => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>
          )
        }
      />

      {err && <div className="mb-4 rounded-2xl bg-white border border-hv-coral/40 p-4 text-hv-coral font-bold text-sm" data-testid="school-analytics-error">{err}</div>}

      {schools && schools.length === 0 && (
        <div className="rounded-2xl bg-white border border-[#E5DFC8] p-10 text-center text-hv-slate" data-testid="school-analytics-empty">
          No schools yet — create one in School Management first.
        </div>
      )}

      <SchoolAnalyticsView schoolId={schoolId} />
    </div>
  );
}
